import infrastructures from "./infrastructures";
import repositories from "./repositories";
import useCases from "./useCases";
import actions from "./actions";
import presenters from "./presenters";
import Http from "@adapters/infrastructures/Http";
import Authorizer from "@adapters/infrastructures/Authorizer";
import { AccountDetails } from "@domains/utils/AccountDetails";
import CommonQuotesHomePageRepository from "@adapters/repositories/Common/QuotesPageRepository";
import { GTMServiceClass } from "@domains/trackers/gtmService";
import QuoteStreamRepo from "@adapters/repositories/stream/QuoteStreamRepo";
import NewsStreamRepo from "@adapters/repositories/liveNewsStream/NewsStreamRepo";
import AdvDecStreamRepo from "@adapters/repositories/advanceDeclineStream/StreamRepo";
import Myworker from "@domains/utils/all.worker";
export const cInfrastructures = infrastructures();
export const worker = new Myworker();
export const accountDetails = new AccountDetails(cInfrastructures.localStorage, cInfrastructures.cookieStorage);
export const GTMService = new GTMServiceClass(cInfrastructures.localStorage);
export const autorize = new Authorizer(cInfrastructures.localStorage, cInfrastructures.cookieStorage);
export const http = new Http(autorize, cInfrastructures.localStorage);
export const commonQuotesHomePageRepository = new CommonQuotesHomePageRepository(http);
export const qouteStream = new QuoteStreamRepo(cInfrastructures.stream);
export const newsStream = new NewsStreamRepo(cInfrastructures.stream);
export const advDecStream = new AdvDecStreamRepo(cInfrastructures.stream);
const cRepositorires = repositories(http);
const cUseCases = useCases(cRepositorires);
const cActions = actions();
const cPresenters = presenters(cUseCases, cActions);
export default {
    header: cPresenters.header,
    home: cPresenters.home,
    footer: cPresenters.footer,
    common: cPresenters.common,
    liveNews: cPresenters.liveNews,
};
